import { CommercialType } from '@talon/web/lib/api';
import { Box, Button, Text } from 'grommet';
import { WizardSegmentedControl } from '../WizardSegmentedControl';

interface IMediaTabProps {
  media?: CommercialType[];
  setMedia: (value: CommercialType[]) => void;
  mediaOptions: CommercialType[];
  exclusivity?: string;
  setExclusivity: (value: string) => void;
}

export const MediaTab = ({ media = [], setMedia, mediaOptions, exclusivity, setExclusivity }: IMediaTabProps) => (
  <Box pad="medium" gap="medium">
    <Text size="14px" weight={600} color="#222">What will you produce?</Text>
    <Box direction="row" gap="small" wrap>
      {mediaOptions.map((medium) => {
        const selected = media.includes(medium);
        return <Button key={medium} role="checkbox" aria-checked={selected}
          label={`${selected ? '✓ ' : ''}${medium}`}
          onClick={() => setMedia(selected ? media.filter((item) => item !== medium) : [...media, medium])}
          style={{ minHeight: 40, borderRadius: 20, padding: '0 14px', border: `1px solid ${selected ? '#0d48a1' : '#BBB'}`,
            background: selected ? '#e8eef8' : 'white', color: selected ? '#0d48a1' : '#333' }} />;
      })}
    </Box>
    <Text size="14px" weight={600} color="#222">Does the client want exclusivity?</Text>
    <WizardSegmentedControl name="exclusivity" options={[
      { label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' },
    ]} value={exclusivity} onChange={setExclusivity} />
    {(exclusivity === 'yes' || media.includes(CommercialType.TV)) && (
      <Box background="#F2F2F2" round="8px" pad={{ vertical: '9px', horizontal: '12px' }}>
        <Text size="13px" color="#444">This will shoot under the broadcast contract because{' '}
          {exclusivity === 'yes' ? 'the client wants exclusivity' : 'it will air on TV'}.</Text>
      </Box>
    )}
  </Box>
);
